import { useMemo, useState } from 'react';

const INITIAL_ITEMS_COUNT = 5;

const useLoadMore = <T>(items: T[]) => {
  const [showAll, setShowAll] = useState(false);
  const hasMoreItems = items.length > INITIAL_ITEMS_COUNT;

  const displayedItems = useMemo(
    () => (showAll || !hasMoreItems ? items : items.slice(0, INITIAL_ITEMS_COUNT)),
    [items, showAll, hasMoreItems],
  );

  const remainingCount = items.length - INITIAL_ITEMS_COUNT;

  const toggleShowAll = () => setShowAll((prev) => !prev);

  return { displayedItems, showAll, hasMoreItems, remainingCount, toggleShowAll };
};

export default useLoadMore;
